import "core-js/modules/es7.array.includes";
import router from '@/router';
router.afterEach(function (to, from) {
  function checkCardTypeManage(path) {
    var noChangePath = ['/channelManage/channelCardType',
    // 渠道
    '/themeManage/channelCardTypeManage',
    // 管理中心
    '/platformConfig/standardCardType',
    // 平台配置
    '/manageCenter/specialCardTypeManage' // 特殊
    ];
    var flag = noChangePath.includes(path);
    return flag;
  }
  if (!checkCardTypeManage(to.path)) {
    // 设置 rem 函数
    var setRem = function setRem() {
      // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
      var scale = document.documentElement.clientWidth / 1920;
      // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
    }; // 初始化
    // rem等比适配配置文件
    // 基准大小
    var baseSize = 16;
    setRem();
    // 改变窗口大小时重新设置 rem
    window.onresize = function () {
      setRem();
    };
  }
});